import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import {
  FilesPreviewGallery,
  useFilePreviewGallery,
} from '../../../FilesPreviewGallery'
import { getTableRowQaProps, TableCellFreeSpaceFiller } from '../../../Table'
import { toMultiListFiles } from '../../DocFlow.utils.files'
import { DocFlowSendingFieldName } from '../DocFlowSending.constants'

import { renderCell } from './DocFlowSendingResultTableRow.utils'

import * as styles from './DocFlowSendingResultTableRow.module.css'

function DocFlowSendingResultTableRow({
  columns,
  emptyColumnSize,
  isLoading,
  isResizing,
  isShort,
  item,
  phaseDisabled,
  resizingColumn,
  scrollRef,
  showCellBorder,
}) {
  const { t } = useTranslation()

  const { activeFileIndex, handleClickFile, handleCloseFilePreview } =
    useFilePreviewGallery({
      files: item[DocFlowSendingFieldName.File],
    })

  const preparedFiles = toMultiListFiles(item[DocFlowSendingFieldName.File], t)

  const qaProps = getTableRowQaProps()

  return (
    <>
      <div {...qaProps} className={styles.DocFlowSendingResultTableRow}>
        {columns.map(column => (
          <Fragment key={column.name}>
            {renderCell({
              isActive: column.name === resizingColumn,
              isLoading,
              isResizing,
              isShort,
              item,
              name: column.name,
              phaseDisabled,
              preparedFiles,
              scrollRef,
              showCellBorder,
              t,
              width: column.width,
              onClickFile: handleClickFile,
            })}
          </Fragment>
        ))}
        <TableCellFreeSpaceFiller width={emptyColumnSize} />
      </div>
      <FilesPreviewGallery
        files={item[DocFlowSendingFieldName.File]}
        initActive={activeFileIndex}
        onClose={handleCloseFilePreview}
      />
    </>
  )
}

export default DocFlowSendingResultTableRow
